"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getSaleableProductIdsKeyedByType = _interopRequireDefault(require("../get-saleable-product-ids-keyed-by-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getSaleableCombinedProductIds = function getSaleableCombinedProductIds(date) {
  var _getSaleableProductId, _getSaleableProductId2;
  var saleableProductIdsHospital = (_getSaleableProductId = (0, _getSaleableProductIdsKeyedByType["default"])(date)) === null || _getSaleableProductId === void 0 ? void 0 : _getSaleableProductId.hospital;
  var saleableProductIdsExtras = (_getSaleableProductId2 = (0, _getSaleableProductIdsKeyedByType["default"])(date)) === null || _getSaleableProductId2 === void 0 ? void 0 : _getSaleableProductId2.extras;
  return (0, _fp.flatMap)(function (hospitalId) {
    return (0, _fp.map)(function (extrasId) {
      return "".concat(hospitalId, "-").concat(extrasId);
    })(saleableProductIdsExtras);
  })(saleableProductIdsHospital);
};
var _default = exports["default"] = getSaleableCombinedProductIds;
module.exports = exports.default;